import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IAppState } from '../../web-legacy/models/reduxState';
import {
  updateAccentColor,
  updateDeeplink,
  updateGetHelpSignInStatus,
  updateTheme,
} from '../../web-legacy/packages/app/appActions';
import {
  diagnosticCompletion,
  diagnosticError,
} from '../../web-legacy/packages/contactUs/reduxUpdater/actions/diagnosticActions';
import {
  dispatchGetHelpTokenError,
  dispatchGetHelpTokenReceived,
  dispatchUpdateGetHelpConfigurations,
} from '../../web-legacy/packages/contactUs/reduxUpdater/dispatchers/contactUsDispatchers';
import { ActionPayload } from '../common/actions/base.actions';
import { ExternalCommand } from '../models/constants/getHelpConstants';

export const eventHandlers: Record<
  string,
  (payload: ActionPayload) => Action | ThunkAction<void, IAppState, null, Action<ActionPayload>>
> = {
  [ExternalCommand.UpdateColor]: updateAccentColor,
  [ExternalCommand.UpdateTheme]: updateTheme,
  [ExternalCommand.UpdateDeeplink]: updateDeeplink,
  [ExternalCommand.UpdateConfigurations]: dispatchUpdateGetHelpConfigurations,
  [ExternalCommand.DiagnosticResult]: diagnosticCompletion,
  [ExternalCommand.DiagnosticError]: diagnosticError,
  [ExternalCommand.UpdateAuthToken]: dispatchGetHelpTokenReceived,
  [ExternalCommand.UpdateAuthError]: dispatchGetHelpTokenError,
  [ExternalCommand.UpdateSignInStatus]: updateGetHelpSignInStatus,
};
